export default __webpack_public_path__ + "static/media/apple.8994a464.svg";